<template>
  <v-card class="pt-4 px-4 px-sm-6 pb-6">
    <v-card-title class="px-0">
      <v-sheet class="d-flex flex-column align-center" width="100%">
        <v-sheet class="pa-3 rounded-circle" color="#d0fae5">
          <v-btn color="#00bc7d" depressed small fab>
            <v-icon color="white" size="20"> mdi-check </v-icon>
          </v-btn>
        </v-sheet>

        <TitleWidget class="mt-2" small>Link Criado com Sucesso</TitleWidget>

        <div class="grey--text text--darken-2 text-body-2 text-center mt-1">
          Seu link foi gerado e está pronto para ser compartilhado
        </div>
      </v-sheet>

      <v-btn
        @click.prevent="$emit('close')"
        color="grey darken-3"
        absolute
        right
        icon
        top
      >
        <v-icon size="18">mdi-window-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="px-0 mt-2">
      <v-btn
        @click.prevent="copyClipboard"
        class="d-flex align-center px-3 rounded-lg btn-link"
        color="#f1f1f1"
        width="100%"
        depressed
        x-large
      >
        <v-sheet
          class="d-flex align-center justify-center rounded-lg"
          color="#d0fae5"
          min-width="30px"
          height="30px"
        >
          <v-icon size="18" color="#009966"> mdi-link-variant </v-icon>
        </v-sheet>

        <div
          class="ml-1 black--text text-body-2 text-none font-weight-regular btn-link-text"
        >
          {{ link }}
        </div>
      </v-btn>
    </v-card-text>

    <v-card-actions class="pa-0">
      <v-sheet class="grid-list-btn" width="100%">
        <v-btn
          @click.prevent="$emit('close')"
          class="rounded-lg"
          color="#dddddd"
          outlined
          block
          dense
        >
          <v-icon color="black" size="14" left>mdi-close</v-icon>
          <div class="black--text text-none">Fechar</div>
        </v-btn>

        <v-btn
          @click.prevent="copyClipboard"
          class="rounded-lg"
          color="#00bc7d"
          depressed
          block
          dense
        >
          <v-icon color="white" size="14" left>mdi-content-copy</v-icon>
          <div class="white--text text-none">Copiar link</div>
        </v-btn>
      </v-sheet>
    </v-card-actions>
  </v-card>
</template>

<script>
import TitleWidget from "@/components/widgets/Title.vue";

export default {
  components: { TitleWidget },
  props: {
    link: String,
  },
  methods: {
    async copyClipboard() {
      try {
        await navigator.clipboard.writeText(this.link);

        this.$eventHub.$emit("snackBar", {
          icon: "mdi-clipboard-check-outline",
          message: "Link copiado!",
          type: "info",
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-link::v-deep {
  border: 1px solid #d1d1d1 !important;

  &:hover {
    &:before {
      opacity: 0 !important;
    }
  }

  .v-btn__content {
    max-width: 100%;
  }

  .btn-link-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.grid-list-btn {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}
</style>
